import { NavLink, Table } from 'reactstrap'
import PropTypes from 'prop-types'
import { STATUS as ORDER_STATUS } from 'domains/customer-order/constants'
import { STATUS as BANK_TRANSFER_STATUS } from 'domains/payment-bank-transfer/constants'
import { IsOrderCancelableBadge, PaymentBankTransferStatusBadge } from 'domains/payment-bank-transfer/atoms'
import TimeUtil from 'utils/time-util'
import PriceUtil from 'utils/price-util'

const propTypes = {
  bankTransfer: PropTypes.any
}

const BankTransferTableRow = ({
  bankTransfer
}) => {

  const {
    id,
    customer_name,
    order_number,
    transfer_date,
    transaction_no,
    credit_bank_name,
    credit_account_name,
    credit_account_number,
    debit_tl_bank,
    status,
    order
  } = bankTransfer
  const buttonClassName = 'align-self-center my-1 mx-auto'

  const IsOrderCancelableCell = () => {
    const expiredDate           = new Date(order.expires_at)
    const isOrderPending        = order.status === ORDER_STATUS.PENDING
    const isBankTransferPending = status === BANK_TRANSFER_STATUS.PENDING

    const isOrderCancelable = expiredDate < Date.now() && isOrderPending && isBankTransferPending

    return (
      <IsOrderCancelableBadge isOrderCancelable={ isOrderCancelable } />
    )
  }

  const DescriptionCell = () => (
    <Table
      bordered
      responsive
      size={ 'sm' }
      className='mb-0'
    >
      <tbody>
        <tr>
          <th scope='row'>Trx No.</th>
          <td>{ transaction_no || '-' }</td>
        </tr>
        <tr>
          <th scope='row'>Credit bank</th>
          <td>{ credit_bank_name || '-' }</td>
        </tr>
        <tr>
          <th scope='row'>Credit Acct. Name</th>
          <td>{ credit_account_name || '-' }</td>
        </tr>
        <tr>
          <th scope='row'>Credit Acct No.</th>
          <td>{ credit_account_number || '-' }</td>
        </tr>
        <tr>
          <th scope='row'>Transfer Date</th>
          <td>{ transfer_date ? TimeUtil.format(transfer_date) : '-' }</td>
        </tr>
        <tr>
          <th scope='row'>TL Bank</th>
          <td>{
            debit_tl_bank.id
              ? <>
                <div>{ debit_tl_bank.bank }</div>
                <div>{ debit_tl_bank.account_number }</div>
                <div>{ debit_tl_bank.account_name }</div>
              </>
              : '-'
          }</td>
        </tr>
      </tbody>
    </Table>
  )

  return (
    <tr>
      <td>{ TimeUtil.format(transfer_date) }</td>
      <td>{ order_number }</td>
      <td>{ customer_name }</td>
      <td>{ PriceUtil.format(order.total) }</td>
      <td><DescriptionCell /></td>
      <td>{ TimeUtil.format(order.expires_at) }</td>
      <td><IsOrderCancelableCell /></td>
      <td><PaymentBankTransferStatusBadge status={ status } /> </td>
      <td>
        <NavLink
          className={ `btn btn-primary text-white ${buttonClassName}` }
          href={ `/app/finance/orders/payments/bank_transfer/${id}` }
        >
          { 'Detail' }
        </NavLink>
      </td>
    </tr>
  )
}

BankTransferTableRow.propTypes = propTypes
export default BankTransferTableRow